import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { TODO_SHARE_TITLE_SUFFIX } from '../../utils/todoShareTitle';

export type TodoShareBoardCreateModalProps = {
  open: boolean;
  busy?: boolean;
  error?: string;
  onClose: () => void;
  onCreate: (payload: { title: string; code?: string }) => void | Promise<void>;
};

const TodoShareBoardCreateModal: React.FC<TodoShareBoardCreateModalProps> = ({
  open,
  busy = false,
  error = '',
  onClose,
  onCreate,
}) => {
  const [title, setTitle] = useState('새 노트');

  useEffect(() => {
    if (!open) return;
    setTitle('새 노트');
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="cp-todo-share-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="cp-todo-share-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-todo-share-create-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="cp-todo-share-modal-header">
          <h3 id="cp-todo-share-create-title">새 TODO 노트</h3>
          <button type="button" className="cp-todo-share-modal-close" onClick={onClose} aria-label="닫기">
            ×
          </button>
        </div>
        <p className="cp-todo-share-hint">
          먼저 이름만 정하면 됩니다. 공유가 필요하면 노트 설정에서 공유로 바꾸고 입장코드를 적용하세요.
        </p>
        <label className="cp-todo-share-modal-label">
          제목
          <div className="cp-todo-share-title-field">
            <input
              type="text"
              value={title}
              maxLength={60}
              disabled={busy}
              onChange={(e) => setTitle(e.target.value)}
              aria-describedby="cp-todo-share-create-title-hint"
            />
            <span className="cp-todo-share-title-suffix" id="cp-todo-share-create-title-hint">
              {TODO_SHARE_TITLE_SUFFIX}
            </span>
          </div>
        </label>
        {error ? <p className="cp-todo-note-error">{error}</p> : null}
        <div className="cp-todo-share-modal-actions">
          <button type="button" className="cp-btn-secondary" disabled={busy} onClick={onClose}>
            취소
          </button>
          <button
            type="button"
            className="cp-btn-save-all"
            disabled={busy || !title.trim()}
            onClick={() => void onCreate({ title: title.trim() })}
          >
            {busy ? '만드는 중…' : '만들기'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TodoShareBoardCreateModal;
